<template>
  <video ref="video" controls muted autoplay playsinline :src="src" :key="src"></video>
</template>

<script>
import Hls from 'hls.js';

export default {
  props: {
    src: String
  },
  data() {
    return {
      hls: null,
      hlsSupported: Hls.isSupported(),
      componentDestroyed: false
    };
  },
  watch: {
    src() {
      this.init();
    }
  },
  methods: {
    destroy() {
      if(this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
    },
    init() {
      this.destroy();
      const src = this.src;
      if(!src) return;
      this.$nextTick(() => {
          if(this.src !== src) return;
          const video = this.$refs.video;
          if(!video) return;
          if(this.hlsSupported) {
              const hls = new Hls({
                liveSyncDurationCount: 3,
                liveMaxLatencyDurationCount: 6,
                liveDurationInfinity: true,
                liveBackBufferLength: 0
              });
              this.hls = hls;
              hls.attachMedia(this.$refs.video);
              hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                console.log("video and hls.js are now bound together!");
                hls.loadSource(src);
              });
              hls.on(Hls.Events.ERROR, function (event, data) {
                if(!data.fatal) return;
                console.log(data);
                if(data.type === Hls.ErrorTypes.NETWORK_ERROR) {
                  console.log("fatal network error encountered, try to recover");
                  hls.startLoad();
                  return;
                }
                if(data.type === Hls.ErrorTypes.MEDIA_ERROR) {
                  console.log("fatal media error encountered, try to recover");
                  hls.recoverMediaError();
                  return;
                }
                console.log("fatal error encountered, destroing the player");
                this.destroy();
              });
              hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                console.log("manifest loaded, found " + data.levels.length + " quality level");
                video.muted = true;
                video.play();
              });
          }
      })
    }
  },
  mounted () {
    this.init();
  },
  beforeDestroy() {
    this.destroy();
    this.componentDestroyed = true;
  }
}
</script>





// WEBPACK FOOTER //
// Player.vue?686a0f67